var _rect, _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardButtonImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 140,
    viewBox: "0 0 145 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 140,
    fill: "url(#paint0_linear_5245_69964)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87 22H56V53H87V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 22C37.9487 23.1793 25.1415 36.411 24 53H54V22Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 55H24V86H54V55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 55H89V86H120V55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 118C105.592 116.864 118.82 104.057 120 88H89V118Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87 88H56V118H87V88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 88H24C25.136 104.062 37.9377 116.864 54 118V88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 15V47H126C125.995 29.327 111.668 15 94 15Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0972 70.2C38.0972 76.052 42.3812 80.168 48.0092 80.168C52.3492 80.168 55.8772 77.872 57.1932 73.84H52.6852C51.7612 75.744 50.0812 76.668 47.9812 76.668C44.5652 76.668 42.1292 74.148 42.1292 70.2C42.1292 66.224 44.5652 63.732 47.9812 63.732C50.0812 63.732 51.7612 64.656 52.6852 66.532H57.1932C55.8772 62.528 52.3492 60.204 48.0092 60.204C42.3812 60.204 38.0972 64.348 38.0972 70.2ZM59.5334 72.188C59.5334 77.032 62.6694 80.252 66.5894 80.252C69.0534 80.252 70.8174 79.076 71.7414 77.732V80H75.6894V64.488H71.7414V66.7C70.8174 65.412 69.1094 64.236 66.6174 64.236C62.6694 64.236 59.5334 67.344 59.5334 72.188ZM71.7414 72.244C71.7414 75.184 69.7814 76.808 67.6254 76.808C65.5254 76.808 63.5374 75.128 63.5374 72.188C63.5374 69.248 65.5254 67.68 67.6254 67.68C69.7814 67.68 71.7414 69.304 71.7414 72.244ZM83.4379 72.272C83.4379 69.276 84.8379 68.38 87.1619 68.38H88.1979V64.264C86.0419 64.264 84.4179 65.3 83.4379 66.896V64.488H79.5179V80H83.4379V72.272ZM89.8302 72.188C89.8302 77.032 92.9663 80.252 96.9143 80.252C99.3503 80.252 101.086 79.132 102.01 77.704V80H105.986V59.28H102.01V66.644C100.946 65.188 98.9863 64.236 96.9423 64.236C92.9663 64.236 89.8302 67.344 89.8302 72.188ZM102.038 72.244C102.038 75.184 100.078 76.808 97.9223 76.808C95.8223 76.808 93.8343 75.128 93.8343 72.188C93.8343 69.248 95.8223 67.68 97.9223 67.68C100.078 67.68 102.038 69.304 102.038 72.244Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5245_69964",
    x1: 72.5,
    y1: 0,
    x2: 72.5,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB7BD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#934FAD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardButtonImage);
export default __webpack_public_path__ + "static/media/CardButtonImage.6b8edae5133e1b1b6197f06704b901b3.svg";
export { ForwardRef as ReactComponent };